<template>
    <div class="kce-hero">
        <div class="kce-hero__background kce-home__hero kce-home__hero-kce" v-if="isUserKCE">
            <div class="kce-container">
                <div class="kce-row">
                    <div class="kce-hero__wrapper">
                        <div class="kce-container">
                            <div class="kce-row">
                                <div class="kce-hero-user-certify__wrapper">
                                    <p class="kce-feature-heading kce-feature-heading-one">JOIN OUR OFFICIAL KENO
                                        FACEBOOK GROUP.</p>

                                    <p class="kce-feature-heading kce-feature-heading-two">GET IN ON OUR SECRET STASH
                                    </p>

                                    <p class="kce-feature-heading kce-feature-heading-three">OF KENO TEACHING, SELLING
                                        &amp; PLAYING TIPS,</p>

                                    <p class="kce-feature-heading kce-feature-heading-four">PROMOS, BONUS INFO, STATS
                                        AND ALL KINDS OF OTHER
                                        MONEY-MAKING SHENANIGANS</p>

                                    <a class="btn btn-primary btn-lg btn-wide"
                                        href="https://www.facebook.com/groups/581791539296914/" target="_blank">
                                        Join The Fun
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kce-hero__background kce-home__hero kce-home__hero-nonkce" v-else>
            <div class="kce-container">
                <div class="kce-row">
                    <div class="kce-hero__wrapper">
                        <div class="kce-container">
                            <div class="kce-row">
                                <div class="kce-hero-user-certify__wrapper">
                                    <p class="kce-feature-heading kce-feature-heading-one"><span class="balance-text"
                                            style="">BECOME A KENO CERTIFIED EXPERT</span></p>

                                    <p class="kce-feature-heading kce-feature-heading-two"><span class="balance-text"
                                            style="">THE BUCKS START HERE.</span></p>

                                    <p class="kce-feature-heading kce-feature-heading-three"><span class="balance-text"
                                            style="">YOU TEACH. THEY PLAY. THEY WIN.</span></p>

                                    <p class="kce-feature-heading kce-feature-heading-four"><span class="balance-text"
                                            style="">YOU GET A BIG FAT WALLET. A REALITY<br
                                                data-owner="balance-text">SERIES. AN OFFSHORE ACCOUNT.</span></p>

                                    <p class="kce-feature-heading kce-feature-heading-five"><span class="balance-text"
                                            style="">HOLY TIP JAR BABY THIS IS HAPPENING.</span></p>

                                    <a class="btn btn-primary btn-lg btn-wide "
                                        href="/keno-certified-expert/quiz" target="_blank">
                                        Take the Quiz
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data: function() {
        return {
            isUserKCE: false
        }
    },
    methods: {
        checkForRole() {
            // alert('Checking for Role');
            let apiToken = $cookies.get('apiToken');
            let usersRoles = apiToken.user.listOfRoles;
            console.log("From Home Hero");
            console.log(usersRoles); 

            if (usersRoles.includes('KenoCertifiedExpert')) {
                this.isUserKCE = true;
            }
        }
    },
    mounted: function () {
        this.checkForRole();
    }
}
</script>